import { render, staticRenderFns } from "./MdInsights.vue?vue&type=template&id=bfb60f1a&scoped=true&"
import script from "./MdInsights.vue?vue&type=script&lang=js&"
export * from "./MdInsights.vue?vue&type=script&lang=js&"
import style0 from "./MdInsights.vue?vue&type=style&index=0&id=bfb60f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb60f1a",
  null
  
)

export default component.exports